import { gql } from 'graphql-request';

import cookiePage from './cookiePage';
import responsibleGamblingPage from './responsibleGamblingPage';
import supportPage from './supportPage';

const plusQuery2 = gql`query Plus2 {
  ${cookiePage}
  ${responsibleGamblingPage}
  ${supportPage}
}`;

export default plusQuery2;
